
export async function faqContent() {
    const el = document.querySelector('.js-faq-content')
    let {default: Collapse} = await import('bootstrap/js/dist/collapse')
    new Collapse(el, {toggle: false});
    el.addEventListener('show.bs.collapse', (e) => {
        const faq_content = e.target
        const faq_id = faq_content.getAttribute('id');
        const toggler = document.querySelector('[data-target="#' + faq_id + '"]')

        toggler.textContent = toggler.getAttribute('data-close');
    });

    el.on('hide.bs.collapse', (e) => {
        const faq_content = e.target;
        const faq_id = faq_content.getAttribute('id');
        const toggler = document.querySelector('[data-target="#' + faq_id + '"]');

        toggler.textContent = toggler.getAttribute('data-open')
    });
}